import { Icon } from "antd";
import styled from "styled-components";

export const LoadingIcon = styled(Icon)`
    margin-right: 10px;
`;
